import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./components/Header";
import LandingPage from "./components/LandingPage";
import Tiles from "./components/Tiles";

const App = () => {
  return (
    <Router>
      <Switch>
        <Route path="/">
          <Header />
          <LandingPage />
          <Tiles />
        </Route>
      </Switch>
    </Router>
  );
};
export default App;
